const locale_fr = 'fr-FR';

export function getDisplayTime(date: Date = new Date(), locale = locale_fr) {
    return date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
}

export function getDisplayDate(date: Date = new Date(), locale = locale_fr) {
    return date.toLocaleDateString(locale);
}
